const API = "https://jm.komerzy.com/backend/?url=empleadoapi";

// ======================
// LISTAR
// ======================
export const getEmpleados = async () => {
  const res = await fetch(`${API}&action=listar`);
  const json = await res.json();
  return json.data;
};

// ======================
// VALIDAR DNI
// ======================
export const validarDni = async (dni) => {
  const res = await fetch(`${API}&action=validarDni&dni=${dni}`);
  return await res.json();
};

// ======================
// REGISTRAR
// ======================
export const guardarEmpleado = async (data) => {
  const res = await fetch(`${API}&action=registrarEmpleado`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

// ======================
// ACTUALIZAR
// ======================
export const actualizarEmpleado = async (data) => {
  const res = await fetch(`${API}&action=actualizarEmpleado`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

// ======================
// ELIMINAR
// ======================
export const eliminarEmpleado = async (data) => {
  const res = await fetch(`${API}&action=eliminarEmpleado`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};